module.exports = __webpack_public_path__ + "static/media/HelveticaNowText-Medium.1b786644.woff";